module.exports = __webpack_public_path__ + "eb76a703ad8dd2885887f5fe12802d62.png";